import { useEffect, useState } from 'react';
import { API_URL } from 'src/environments/environment';
import { DEFAULT_HEADERS } from 'src/shared/constants';
import { PurchasedSubscription } from 'pages/Personal/Personal.types';

const usePurchasedSubscriptions = (reFetch: boolean | undefined = undefined) => {
  const [
    purchasedSubscriptions,
    setPurchasedSubscriptions,
  ] = useState<PurchasedSubscription[] | undefined>(undefined);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const getData = async () => {
      const data = await fetch(`${API_URL}/purchased-subscriptions`, {
        method: 'GET',
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${token}`,
        },
      });
      const jsonData = await data.json();
      setPurchasedSubscriptions(jsonData.filter((subscription: any) => subscription.isPaid));
    };

    getData();
  }, [reFetch]);
  return { purchasedSubscriptions };
};

export default usePurchasedSubscriptions;
